export const PLAYER_PREFERENCES = {
  volumeLevel: 0,
};

export const PLAYER_IN_LOCALSTORAGE = 'player-preferences';

export const DEFAULT_VOLUME = 0.5;
